import TFGSubjects from './TFGSubjects';

export default TFGSubjects;
